// Module
var code = "<md-datepicker mn-date ng-model=\"vm.search\"\n               md-placeholder=\"{{ 'search' | translate }}\"\n               ng-change=\"vm.change()\" ng-model-options=\"{ debounce: 400 }\">\n</md-datepicker>";
// Exports
module.exports = code;